import { Spinner } from '@infotrack/zenith-ui'

const Fallback = () => {
  return <Spinner fullSize={true} />
}

export default Fallback
